import React, { useEffect, useRef } from 'react';
import { runtime, Util } from 'codeArt/common';
import ReactEcharts from "echarts-for-react";
import echarts from 'echarts';
import { theme } from '../Base';

export default class BarChart extends React.Component {

    constructor(props) {
        super(props);
    }

    labelFormat(params, data) {

        let name = params.seriesName;
        if (name.indexOf('series') > -1) name = params.name;

        let value = params.value;
        let item = data.find((t) => { return t.type == name }) || {};

        let index = params.seriesIndex;
        let obj = item.format ? item.format(value, name, index) : { name, value };
        let marker = params.marker;

        return { marker, name: obj.name, value: obj.value, index }
    }

    getOption() {
        let { data, color, tooltip, barWidth, barMaxWidth, grid, legend, title, line, lineType, y, x, label, horizontal, lineColor } = this.props;
        let option = {}; let my = this;

        if (title) {
            option.title = {
                text: title,
                textStyle: {
                    fontSize: 16,
                    fontWeight: 400,
                    color: theme.color.dark
                }
            }
        }


        if (tooltip) {
            option.tooltip = {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: function (params) {
                    let { data } = my.props;
                    let { marker, name, value } = my.labelFormat(params[0], data);
                    let tip = `${marker}${name} : ${value}`
                    return tip;
                }
            }
        }

        option.grid = { left: '10', right: '25', bottom: '20', containLabel: true }; //自定义图表两边留空
        option.grid = Object.assign(option.grid, grid);



        let types = [];
        let series = [];

        data.forEach((t) => {
            types.push(t.type);
            series.push(t.value);
        })

        let scaleAxis = {
            type: 'category',
            data: types,
            name: horizontal ? y.name : x.name,
            axisTick: {
                alignWithLabel: true
            }
        }

        let dataAxis = {
            type: 'value',
            name: horizontal ? x.name : y.name,
            splitLine: {
                show: line, //网格线是否显示
                lineStyle: {
                    type: lineType, //网格线类型 solid：直线；dashed：短横线；dotted：点
                    color: lineColor,
                }
            },
            axisLabel: {
                show:true,
                formatter: function (value) {
                    let obj = horizontal ? x : y;
                    return obj.format ? obj.format(value) : value;
                }
            }
        }

        let xAxis = horizontal ? dataAxis : scaleAxis;
        option.xAxis = {
            ...xAxis,
            ...x
        }

        option.series = [{
            type: 'bar',
            barWidth: barWidth,
            barMaxWidth,
            data: series,
            label: !label ? null : {
                show: true,
                position: "top",
                formatter: function (p) {
                    var obj = my.labelFormat(p, data);
                    return obj.value;
                },
                ...label
            },
            itemStyle: {
                normal: {
                    color: function (params) {  //自定义柱状图 颜色
                        let name = params.name;
                        let item = data.find(t => t.type == name);
                        return item != null ? item.color || color : color;
                    }
                }
            }
        }]

        let yAxis = horizontal ? scaleAxis : dataAxis;
        option.yAxis = {
            ...yAxis,
            ...y
        }

        return option;
    }

    render() {
        return <ReactEcharts option={this.getOption()} notMerge={true} lazyUpdate={true} height="auto" className={"w-100 h-100"} />
    }
}

BarChart.defaultProps = {
    y: { name: "" },
    x: { name: "" },
    data: [],
    barWidth: '60%',
    barMaxWidth: '60%',
    color: "#3398DB",
    lineColor: "#f0f0f0",
    tooltip: true,
    line: true,
    lineType: 'solid',
    horizontal: false,
}

BarChart.propTypes = {

};

export class MultiBarChart extends React.Component {
    constructor(props) {
        super(props);
    }

    getOption() {
        let { data, grid, x, y, horizontal, label, legend, tipFormat, barWidth, title, titleStyle } = this.props;
        let option = {};
        let my = this;

        if (title) {
            option.title = {
                text: title,
                textStyle: {
                    fontSize: 16,
                    fontWeight: 400,
                    color: theme.color.dark,
                    ...titleStyle
                }
            };
        }

        option.tooltip = {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            formatter: function (params) {
                let tip = "";
                let name = "";
                params.forEach(t => {
                    name = t.name;
                    let item = `${t.marker}${t.seriesName} : ${tipFormat ? tipFormat(t.value) : t.value} </br>`;
                    tip = item + tip;
                });

                return `${name}</br>${tip}`;
            }
        };

        if (legend) option.legend = { data: data.map((t) => t.type) };

        option.grid = { left: "10", right: "10", bottom: "10", top: "40", containLabel: true };
        option.grid = Object.assign(option.grid, grid);


        let xData = x.data;
        let xAxis = [
            {
                type: "category",
                axisLine: { show: true },
                axisTick: { alignWithLabel: true },
                axisLabel: { show: true },
                splitArea: { show: false },
                splitLine: { show: false },
                data: xData
            }
        ];

        let yAxis = [
            {
                type: "value",
                name: y.name,
                axisLine: { show: true },
                splitLine: { show: false },
                axisLabel: {
                    formatter: v => {
                        return y.format ? y.format(v) : v;
                    }
                },
                ...y
            },
        ];


        option.xAxis = horizontal ? yAxis : xAxis;
        option.yAxis = horizontal ? xAxis : yAxis;

        let series = data.map((t) => {
            return {
                name: t.type,
                type: "bar",
                barGap: "0%",
                barWidth: barWidth || "35%",
                xAxisIndex: 0,
                itemStyle: { normal: { color: t.color || theme.color.blue } },
                data: t.data,
                label: !label ? null : {
                    show: true,
                    position: "top",
                    backgroundColor: "transparent",
                    formatter: v => {
                        return t.format ? t.format(v.value) : v.value;
                    },
                    ...label
                },
            }
        })

        option.series = series;

        return option;
    }

    getEvents() {
        let { onClick } = this.props;
        if (!onClick) return {};
        return { click: onClick };
    }

    render() {
        return (
            <ReactEcharts option={this.getOption()} notMerge={true} lazyUpdate={true} className={"w-100 h-100"} onEvents={this.getEvents()} />
        );
    }
}

MultiBarChart.defaultProps = { legend: true, y: {}, x: {} };



/*
export class MultiBarChart extends React.Component {

    constructor(props) {
        super(props);
    }


    getCommon() {
        let { data, color, tooltip, barWidth, grid, title, line, x, y, label } = this.props;
        let option = {}; let my = this;




        if (tooltip) {
            option.tooltip = {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: function (params) {
                    let tips = [];
                    let { data } = my.props;
                    params.forEach((t, i) => {
                        let p = params[i];
                        if (p.value) tips.push(my.commonFormat(p, data));
                    })

                    tips = tips.map((t) => {
                        return `${t.marker}${t.name} : ${t.value}`;
                    });

                    return tips.join('<br/>');
                }
            }
        }

        option.xAxis = {
            type: 'category',
            data: x.data,
            axisTick: { show: false },
        }


        let series = data.map((t, i) => {
            return {
                name: t.type,
                barWidth: barWidth,
                type: 'bar',
                backgroundColor: "transparent",
                barGap: 0,
                label: label ? this.labelOption() : null,
                data: t.value
            };
        });

        option.series = series;
        return option;
    }

    commonFormat(params, data) {

        let name = params.seriesName;
        if (name.indexOf('series') > -1) name = params.name;

        let value = params.value;
        let item = data.find((t) => { return t.type == name }) || {};

        let index = params.seriesIndex;
        let group = item.group[index];
        let obj = item.format ? item.format(value, group, index) : { name, value };
        let marker = params.marker;

        return { marker, name: obj.name, value: obj.value, index }
    }

    labelOption() {
        let { data, self, label } = this.props;
        let my = this;
        return {
            show: true,
            position: 'insideBottom',
            distance: 15,
            backgroundColor: "transparent",
            align: "left",
            verticalAlign: 'middle',
            rotate: 90,
            formatter: function (params) {
                let p = {};
                if (self) {
                    p = my.selfFormat(params, data);
                } else {
                    p = my.commonFormat(params, data);
                }

                return `${p.name}  ${p.value}`;
            },
            fontSize: 14,
            rich: {
                name: {
                    textBorderColor: '#fff'
                }
            },
            ...label
        };

    }

    selfFormat(params, data) {
        let name = params.seriesName;
        let index = params.seriesIndex;
        if (name.indexOf('series') > -1) name = params.name;
        let value = params.value[index + 1];
        let item = data.find((t) => { return t.type == name }) || {};
        let group = item.group[index];
        let obj = item.format ? item.format(value, group, index) : { name, value };
        let marker = params.marker;

        return { marker, name: obj.name, value: obj.value, index }
    }

    getSelf() {
        let { data, color, tooltip, barWidth, grid, title, line, x, y, label } = this.props;
        let option = {}; let my = this;

        if (tooltip) {
            option.tooltip = {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: function (params) {
                    let tips = []; let { data } = my.props;
                    params.forEach((t, i) => {
                        let p = params[i];
                        if (p.value[i + 1]) tips.push(my.selfFormat(p, data, i));
                    })

                    tips = tips.map((t) => {
                        return `${t.marker}${t.name} : ${t.value}`;
                    });


                    return tips.join('<br/>');
                }
            }
        }




        option.xAxis = {
            type: 'category',
        }



        let source = [];
        data.forEach((t, i) => {
            let item = Util.clone(t.value);
            item.unshift(t.type);
            source.push(item);
        });

        option.dataset = {
            source: source
        }


        let series = x.data.map((t, i) => {
            return {
                barWidth: barWidth,
                type: 'bar',
                barGap: 0,
                backgroundColor: "transparent",
                label: label ? my.labelOption() : null,
            };
        });

        option.series = series;

        return option;
    }

    getOption() {
        let { color, grid, title, line, y, self, titleStyle, lineColor } = this.props;
        let option = self ? this.getSelf() : this.getCommon();

        if (title) {
            option.title = {
                text: title,
                textStyle: {
                    fontSize: 16,
                    fontWeight: 400,
                    color: theme.color.dark
                    , ...titleStyle
                }
            }
        }

        if (color) option.color = color;

        option.grid = { left: '10', right: '25', bottom: '20', containLabel: true }; //自定义图表两边留空
        option.grid = Object.assign(option.grid, grid);

        option.yAxis = {
            name: y.name,
            type: 'value',
            splitLine: { show: line, lineStyle: { color: lineColor } }, //网格线是否显示
            axisLabel: {
                formatter: function (value) {
                    return y.format ? y.format(value) : value;
                }
            },
            nameTextStyle: {
                width: "100%",
                padding: [0, 0, 0, 10]
            },
            ...y

        }

        return option;
    }

    //有两种模式，第一种根据年份或者其他，来把数组中的关于某某（2019）年 组合成一个分类，对比效果比较明显，一种数据分类自己管理自己 比如苹果2019-2015的数据，就单独的苹果是一个分类，自己管理自己
    render() {
        return <ReactEcharts option={this.getOption()} notMerge={true} lazyUpdate={true} className={"w-100 h-100"} />
    }
}

MultiBarChart.defaultProps = {
    data: [],
    x: { data: [] },
    y: { name: "" },
    data: [],
    barWidth: '20%',
    lineColor: "#f0f0f0",
    tooltip: true,
    line: true,
    self: false,
}

MultiBarChart.propTypes = {

}; */
